var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6857 15.6843C12.7853 15.5849 12.8644 15.4668 12.9183 15.3368C12.9722 15.2067 13 15.0674 13 14.9266C13 14.7859 12.9722 14.6465 12.9183 14.5165C12.8644 14.3865 12.7853 14.2684 12.6857 14.1689L8.51583 9.99906L12.6857 5.82918C12.8867 5.62823 12.9995 5.35569 12.9995 5.07151C12.9995 4.78733 12.8867 4.51478 12.6857 4.31384C12.4848 4.11289 12.2122 4 11.928 4C11.6439 4 11.3713 4.11289 11.1704 4.31384L6.23744 9.24677C6.13781 9.34619 6.05876 9.46429 6.00483 9.5943C5.9509 9.72431 5.92314 9.86368 5.92314 10.0044C5.92314 10.1452 5.9509 10.2846 6.00483 10.4146C6.05876 10.5446 6.13781 10.6627 6.23744 10.7621L11.1704 15.695C11.5788 16.1034 12.2666 16.1034 12.6857 15.6843Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrev);
export default __webpack_public_path__ + "static/media/ic-prev.5ede5ad29bc7de34c1f354a562028b01.svg";
export { ForwardRef as ReactComponent };